import { hasCustomerTrialFeature } from '../features/mercuryCustomerTrial';
// Limited production rollout. The company service independently enforces the
// same tenant allowlist; this gate only controls discovery in Settings.
export const RISK_MODEL_TENANT_ID = 'NSSJKgg7lOCeadPDIS16';
export const isRiskModelStudioEnabled = (tenantId, tenant) => tenantId === RISK_MODEL_TENANT_ID || hasCustomerTrialFeature(tenantId, tenant, 'riskModelStudio');
